import env from "environment"

interface IAppConfig {

    apiUrl: string;
    notificationUrl: string;
    version: string;   
    playStoreUri: string;
    gaTag?: string;
}
 
export class Configuration {

    async loadAsync() {

        const mainConfig = await (await fetch("/config.json")).json() as IAppConfig;

        if (env) {

            try {
                const envConfig = await (await fetch("/config." + env + ".json")).json() as IAppConfig;
                Object.assign(mainConfig, envConfig);
            }
            catch {

            }
        }

        this.current = mainConfig;
    }

    current: IAppConfig;
}


export const config = new Configuration();
